import RegisteredBlockType from '@orgnc/core/components/blocks/Blocks/types';
import { IArticle } from '@orgnc/core/lib/wordpress/api/adapters/articleAdapter';

export const injectAds = (article: IArticle): IArticle => {
  const stripEmptyParagraphs = (
    blocks: IArticle['blocks']
  ): IArticle['blocks'] => {
    let lastContentfulParagraphIndex = 0;
    blocks.forEach((block, index) => {
      if (
        block.name === RegisteredBlockType.CoreParagraphBlock &&
        block.originalContent !== '<p></p>'
      ) {
        lastContentfulParagraphIndex = index;
      }
    });
    // strip all empty paragraphs after last contentful paragraph
    return blocks.filter((block, index) => {
      return !(
        block.name === RegisteredBlockType.CoreParagraphBlock &&
        index > lastContentfulParagraphIndex &&
        block.originalContent === '<p></p>'
      );
    });
  };
  const injectAdToBlocks = (blocks: IArticle['blocks']): IArticle['blocks'] => {
    let lastParagraphIndex = 0;
    blocks.forEach((block, index) => {
      if (block.name === RegisteredBlockType.CoreParagraphBlock) {
        lastParagraphIndex = index;
      }
    });
    if (lastParagraphIndex) {
      return [
        ...blocks.slice(0, lastParagraphIndex),
        ...[
          {
            name: 'acf/htl-ad',
            order: lastParagraphIndex,
            unit: 'MedRec_Content',
            hasBaseHeight: false,
            attributes: {},
            innerBlocks: [],
          },
          {
            ...blocks[lastParagraphIndex],
            order: lastParagraphIndex + 1,
          },
        ],
        ...blocks.slice(lastParagraphIndex + 1),
      ] as IArticle['blocks'];
    }
    return blocks;
  };

  const filteredBlocks = stripEmptyParagraphs(article.blocks);

  return {
    ...article,
    blocks: injectAdToBlocks(filteredBlocks),
  };
};
